<template>
  <div class="search-section">
    <div class="search-section__left">
      <h1 class="search-section__title">
        {{ $tDossier('Check the employer according to the number of the company KRS, NIP') }}
      </h1>
      <div :class="{'_error': inputError}"
           class="search-section__form">
        <div class="search-section__inputs-wrap">
          <div class="search-section__inputs-inner">
            <label class="search-section__input-item">
              <input v-model="inputValue"
                     v-mask="'##########'"
                     type="search"
                     :placeholder="$tDossier('enter the company code')"
                     @keypress.enter.prevent="onSearch"
                     class="search-section__search-input">
            </label>
            <div class="search-section__select-wrap">
              <SCountry v-model="region"
                        :placeholder="$tDossier('Country')"
                        :country-id="165"
                        @loaded="region = $event"
                        class="search-section__select _white"/>
            </div>
          </div>
        </div>
        <button @click.prevent="onSearch"
                :disabled="!inputValue"
                class="search-section__submit-btn base-btn specific-header-search">
          <BaseSvg name="ico-loupe"
                   width="1.3rem"
                   height="1.3rem"/>
        </button>
      </div>
      <BaseInputError :value="$tDossier(inputError)"
                      class="search-section__inputs-error"/>
      <div class="search-section__wrap-description">
        <BaseSvg name="question-icon"
                 class="search-section__question-icon"/>
        <div class="search-section__description">{{ $tDossier('Search by company code text') }}</div>
      </div>
    </div>
    <div class="search-section__right">
      <v-lazy-image :src="dossierPicture"
                    :title="createTitleMixin($tDossier('Search for information by company code'))"
                    :alt="createAltMixin($tDossier('Search for information by company code'))"
                    class="search-section__img"
      ></v-lazy-image>
    </div>
  </div>
</template>

<script>
  import dossierPicture from '@/assets/img/svg/dossier.svg'
  import SCountry from '@/components/loadingSelects/SCountry'
  import BaseInputError from '@/components/BaseInputError'

  export default {
    name: "SearchCompany",
    components: {
      SCountry,
      BaseInputError
    },
    props: {
      companySlugRouteKey: String
    },
    data() {
      return {
        dossierPicture,
        inputValue: null,
        inputError: null,
        region: null
      }
    },
    methods: {
      onSearch() {
        this.inputError = null

        if (!this.inputValue) return

        if(this.inputValue.length !== 10) {
          return this.inputError = 'Company code must contains 10 symbols'
        }

        const query = {}
        if (this.region) {
          query.country_id = this.region ? this.region.id : null
        }

        this.$router.push({
          params: {
            [this.companySlugRouteKey]: this.inputValue
          },
          query
        })
      }
    }
  }
</script>

<style>

</style>
